import { GET, PATCH, POST } from "../../helper/xbi4RestFunctions";
export const createPeopleLead = async (
  org_id: any,
  org_user_id: any,
  data: any
) => {
  const path = `/orgs/${org_id}/users/${org_user_id}/CreatePeopleLead`;
  return await PATCH({ apiUri: path, data })
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
// modified_org_user_id=path_param.get('org_user_id'),
// org_user_id =body.get('org_user_id')
